<template>
  <div v-if="uploadCopy">
    <h1>Common upload</h1>
    <v-btn :to="{ name: 'uploadsCommon' }">
      <v-icon>chevron_left</v-icon>Common uploads
    </v-btn>
    <h3>Information</h3>
    <v-form ref="uploadForm" v-model="valid" lazy-validation>
      <v-text-field
        label="Id"
        v-model="uploadCopy.id"
        v-if="uploadCopy.id"
        outline
        readonly
      />
      <v-combobox
        v-model="descriptionSearch"
        :items="descriptions"
        label="Upload description"
        no-filter
        @input.native="completeDescription($event.srcElement.value)"
        :rules="descriptionRules"
        outline
        v-if="!uploadCopy.id"
      />
      <v-text-field
        label="Description"
        :value="uploadCopy.uploadDescription.body"
        v-if="uploadCopy.id && uploadCopy.uploadDescription"
        outline
        readonly
      />
      <v-input
        :rules="fileRules"
        prepend-icon="attach_file"
        v-if="!uploadCopy.id"
      >
        <UploadButton ripple title="File" @file-update="setFile">
          <template slot="icon-left">
            <v-icon>folder</v-icon>
          </template>
        </UploadButton>
      </v-input>
      <!-- <b:inputText
        label="#{msg.uploadCommon13}"
        rendered="#{uploadCommonBean.id ne null}"
        value="#{uploadCommonBean.upload.path}"
        readonly="true"
      />-->
      <v-checkbox
        label="Archived"
        v-model="uploadCopy.archived"
        v-if="uploadCopy.id"
      />
      <v-btn @click="saveUpload"> <v-icon>save</v-icon>Save </v-btn>
      <v-btn @click="download" v-if="uploadCopy.id">
        <v-icon>picture_as_pdf</v-icon>View
      </v-btn>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import CREATE_UPLOAD from "@/graphql/document/CreateUpload";
import DESCRIPTIONS from "@/graphql/document/Descriptions";
import UPDATE_UPLOAD_ARCHIVED from "@/graphql/document/UpdateUploadArchived";
import UPLOAD from "@/graphql/document/Upload";
import UPLOAD_SIGNED_URL from "@/graphql/document/UploadEntitySignedUrl";
import UploadButton from "vuetify-upload-button";
export default {
  name: "UploadCommon",
  metaInfo() {
    return {
      title: "Common upload",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    upload: {
      query: UPLOAD,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      skip() {
        return !this.$route.params.id;
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: { UploadButton },
  data() {
    return {
      uploadCopy: null,
      descriptions: [],
      descriptionSearch: "",
      fileData: null,
      valid: false,
      descriptionRules: [(v) => !!v || "Description is required"],
      fileRules: [() => !!this.fileData || "File is required"],
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async completeDescription(value) {
      if (!value) {
        this.descriptions = [];
        return;
      }
      this.description = value;
      const response = await this.$apollo.query({
        query: DESCRIPTIONS,
        variables: { term: value }
      });
      this.descriptions = response.data.descriptions;
    },
    setFile(file) {
      // console.log(file);
      this.fileData = file;
    },
    saveUpload() {
      if (this.$refs.uploadForm.validate()) {
        if (this.$route.params.id) {
          this.updateUpload();
        } else {
          this.createUpload();
        }
      }
    },
    async updateUpload() {
      await this.$apollo.mutate({
        mutation: UPDATE_UPLOAD_ARCHIVED,
        variables: {
          id: this.$route.params.id,
          archived: this.uploadCopy.archived
        }
      });
      this.$router.push({ name: "uploadsCommon" });
    },
    async createUpload() {
      const { name, size, type } = this.fileData;
      const result = await this.$apollo.mutate({
        mutation: CREATE_UPLOAD,
        variables: {
          description: this.descriptionSearch,
          filename: name,
          size,
          type
        }
      });
      await this.putUpload(
        result.data.createUpload.signedUrlPut,
        this.fileData
      );
      this.$router.push({ name: "uploadsCommon" });
    },
    async putUpload(signedUrl, file) {
      try {
        await fetch(signedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type
          }
        });
      } catch (err) {
        console.error(err);
        this.snackbarText = err.message ? err.message : "An error has occurred";
        this.snackbar = true;
      }
    },
    async download() {
      const response = await this.$apollo.query({
        query: UPLOAD_SIGNED_URL,
        variables: { id: this.$route.params.id }
      });
      window.open(response.data.upload.signedUrlGet, "_blank");
    }
  },
  watch: {
    upload: {
      immediate: true,
      handler() {
        if (this.upload) {
          this.uploadCopy = JSON.parse(JSON.stringify(this.upload));
        } else {
          this.uploadCopy = {
            uploadDescription: {
              body: null
            }
          };
        }
      }
    }
  }
};
</script>
